"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const _ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const actionTypes = _ActionTypes.default(namespace);
    const initialState = {
        modalStatus: false,
        status: 'INITIAL',
        company: undefined,
        firstName: '',
        lastName: '',
        email: '',
        title: '',
        country: '',
        city: '',
        street: '',
        postalCode: '',
        telephone: '',
        avatar: ''
    };
    //#region LENS
    const addNewRecipientFieldLens = (field) => new monocle.Setter((value) => (obj) => {
        const addNewRecipient = Object.assign({}, obj);
        const oldValue = addNewRecipient[field];
        addNewRecipient[field] = value(oldValue);
        return addNewRecipient;
    });
    const modalStatusLens = monocle.Lens.fromProp('modalStatus');
    const errorsLens = new monocle.Setter((value) => (s) => s.status === 'ERROR' ? Object.assign(Object.assign({}, s), { errors: value(s.errors) }) : s);
    //#endregion
    //#region REDUCER METHODS
    const methods = {};
    methods[actionTypes.UPDATE_FIELD] = (state, action) => addNewRecipientFieldLens(action.payload.field).set(action.payload.value)(state);
    methods[actionTypes.CLEAR] = () => (Object.assign({}, initialState));
    methods[actionTypes.SET_MODAL_STATUS] = (state, action) => modalStatusLens.set(action.payload)(state);
    methods[actionTypes.CREATE_NEW_REQUEST] = (state) => addNewRecipientFieldLens('status').set('SAVING')(state);
    methods[actionTypes.CREATE_NEW_SUCCESS] = (state) => addNewRecipientFieldLens('status').set('SAVED')(state);
    methods[actionTypes.CREATE_NEW_FAILED] = (state) => addNewRecipientFieldLens('status').set('FAILED')(state);
    methods[actionTypes.VALIDATE_NEW_FAILURE] = (state, action) => fp.function.compose(errorsLens.set(action.payload.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {})), addNewRecipientFieldLens('status').set('ERROR'))(state);
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return {
        reducer,
        methods,
        initialState
    };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map